var exports = {
  "x": "x52a3aa3b--598448--button",
};

module.exports = exports;
